"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    DialogContentWrapper: ()=>DialogContentWrapper
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const analytics_js_namespaceObject = require("../analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
const ChatbotDataContext_js_namespaceObject = require("../context/ChatbotDataContext.js");
const DialogContentWrapper = ({ ariaDescription, chatContainerHeight, children, isAlertDialogActive })=>{
    const { isMobile } = (0, external_react_namespaceObject.useContext)(ChatbotDataContext_js_namespaceObject.ChatbotDataContext);
    const styleRef = (0, external_react_namespaceObject.useRef)(null);
    const dialogRef = (0, external_react_namespaceObject.useRef)(null);
    const contentWrapperRef = (0, external_react_namespaceObject.useRef)(null);
    const originalStylesRef = (0, external_react_namespaceObject.useRef)({});
    (0, external_react_namespaceObject.useEffect)(()=>{
        let mounted = true;
        const cleanupStyles = ()=>{
            try {
                if (styleRef.current) {
                    styleRef.current.remove();
                    styleRef.current = null;
                }
                const dialog = dialogRef.current;
                if (dialog && originalStylesRef.current.dialog) Object.entries(originalStylesRef.current.dialog).forEach(([key, value])=>{
                    if (void 0 !== value) dialog.style[key] = value;
                });
                const contentWrapper = contentWrapperRef.current;
                if (contentWrapper && originalStylesRef.current.contentWrapper) Object.entries(originalStylesRef.current.contentWrapper).forEach(([key, value])=>{
                    if (void 0 !== value) contentWrapper.style[key] = value;
                });
                if (!mounted) {
                    dialogRef.current = null;
                    contentWrapperRef.current = null;
                    originalStylesRef.current = {};
                }
            } catch (err) {
                analytics_js_default().logError({
                    message: 'DialogContentWrapper Cleanup Error',
                    error: err instanceof Error ? err.message : JSON.stringify(err),
                    context: {
                        ariaDescription,
                        isAlertDialogActive,
                        mounted
                    }
                });
            }
        };
        try {
            const dialog = document.querySelector(`div[aria-describedby="${ariaDescription}"]`);
            if (!dialog || !(dialog instanceof HTMLDivElement)) return void cleanupStyles();
            dialogRef.current = dialog;
            originalStylesRef.current.dialog = {
                height: dialog.style.height || void 0,
                margin: dialog.style.margin || void 0,
                marginTop: dialog.style.marginTop || void 0,
                borderBottomRightRadius: dialog.style.borderBottomRightRadius || void 0,
                borderBottomLeftRadius: dialog.style.borderBottomLeftRadius || void 0
            };
            if (isMobile) {
                dialog.style.height = 'calc(100% - 25px)';
                dialog.style.margin = '0px';
                dialog.style.marginTop = '25px';
                dialog.style.borderBottomRightRadius = '0px';
                dialog.style.borderBottomLeftRadius = '0px';
            } else dialog.style.height = chatContainerHeight;
            const contentWrapper = dialog.querySelector('div');
            if (contentWrapper instanceof HTMLDivElement) {
                contentWrapperRef.current = contentWrapper;
                originalStylesRef.current.contentWrapper = {
                    height: contentWrapper.style.height || void 0,
                    display: contentWrapper.style.display || void 0
                };
                contentWrapper.style.height = '100%';
                contentWrapper.style.display = 'block';
            }
            const style = document.createElement('style');
            styleRef.current = style;
            style.innerHTML = isAlertDialogActive ? `
          div[role="alertdialog"] {
            pointer-events: auto !important;
          }
          div[role="dialog"] {
            pointer-events: none !important;
          }
        ` : `
          iframe#px-captcha-modal {
            pointer-events: auto;
          }
          div[role="dialog"] {
            pointer-events: auto !important;
          }
        `;
            document.head.appendChild(style);
        } catch (err) {
            cleanupStyles();
            analytics_js_default().logError({
                message: 'DialogContentWrapper Error',
                error: err instanceof Error ? err.message : JSON.stringify(err),
                context: {
                    ariaDescription,
                    isAlertDialogActive
                }
            });
        }
        return ()=>{
            mounted = false;
            cleanupStyles();
        };
    }, [
        isAlertDialogActive,
        isMobile,
        chatContainerHeight,
        ariaDescription
    ]);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {
        children: children
    });
};
exports.DialogContentWrapper = __webpack_exports__.DialogContentWrapper;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "DialogContentWrapper"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
